import * as React from 'react';
import Icons from "../mon-compte/Icons";
import { WithTranslation, TranslationProps } from "../../contexts/TranslationContext";

interface PasswordInfosFormProps extends TranslationProps {
  [key: string]: any
}

class PasswordInfosForm extends React.Component<PasswordInfosFormProps> {

  constructor(props: TranslationProps) {
    super(props);
    this.state = {
      lstCheckBox: this.props.lstCheckBox
    }
  }

  render()  {
      const Filler = (props : any) => {
        return <div className={"passWordFiller"} style={{width: `${props.percentage}%`, background: `${props.couleur}`}}/>
      }

      const ProgressBar = () => {
        const countTrue = Object.values(this.props.lstCheckbox).filter(element => element == true).length;
        const total = Object.values(this.props.lstCheckbox).length;
        const percentage = (countTrue / total) * 100;
        let couleur;
        let securite;
        if(percentage <= 50) {
          couleur = "red";
          securite = this.props.textsContent?.['AUTH_PASSWORD_INFO_SECURITY_LOW'] ?? "faible";
        } else if (percentage < 100) {
          couleur = "orange";
          securite = this.props.textsContent?.['AUTH_PASSWORD_INFO_SECURITY_MEDIUM'] ?? "moyenne";
        } else {
          couleur = "green";
          securite = this.props.textsContent?.['AUTH_PASSWORD_INFO_SECURITY_STRONG'] ?? "forte";
        }
        return (
            <div className={'passWordProgressBarBlock'}>
              <div style={{width: "35%"}}>{this.props.textsContent?.['AUTH_PASSWORD_INFO_SECURITY'] ?? "Sécurité"} <span style={{color: `${couleur}`}}>{securite}</span> </div>
              <div className={"passWordProgressBar"}>
                <Filler percentage={percentage} couleur={couleur}/>
              </div>
            </div>
        )
      }

      return (
          <div className={this.props.monCompte ? "blocPasswordInfos text-left col-md-6 blocPasswordInfosProfil" : "blocPasswordInfos blocPasswordInfosProfil"}>
            <ProgressBar/>
            <div className={'font14 '}>{this.props.textsContent?.['AUTH_PASSWORD_INFO_MUST'] ?? "Votre mot de passe doit contenir :"}</div>
            <div className={'checkBoxErrorPassword'}>
              {renderInput(this.props.lstCheckbox.checkBoxLength)}
              <label className={this.props.lstCheckbox.checkBoxLength ? 'checked' : ''}>
                {this.props.textsContent?.['AUTH_PASSWORD_INFO_NB_CARACTERS'] ?? "8 à 30 caractères"}
              </label>
            </div>
            <div className={'checkBoxErrorPassword'}>
              {renderInput(this.props.lstCheckbox.checkBoxMaj)}
              <label className={this.props.lstCheckbox.checkBoxMaj ? 'checked' : ''}>
                {this.props.textsContent?.['AUTH_PASSWORD_INFO_MAJ'] ?? "1 lettre majuscule"}
              </label>
            </div>
            <div className={'checkBoxErrorPassword'}>
              {renderInput(this.props.lstCheckbox.checkBoxMin)}
              <label className={this.props.lstCheckbox.checkBoxMin ? 'checked' : ''}>
                {this.props.textsContent?.['AUTH_PASSWORD_INFO_MINUS'] ?? "1 lettre minuscule"}
              </label>
            </div>
            <div className={'checkBoxErrorPassword'}>
              {renderInput(this.props.lstCheckbox.checkBoxChiffre)}
              <label className={this.props.lstCheckbox.checkBoxChiffre ? 'checked' : ''}>
                {this.props.textsContent?.['AUTH_PASSWORD_INFO_NUMBER'] ?? "1 chiffre"}
              </label>
            </div>
          </div>
      );
  }
} export default WithTranslation(PasswordInfosForm, 'AUTH_TUNNEL');

function renderInput(props : boolean) {
  return (<Icons className={props ? 'checked ' : undefined} icon="checkedCircle" size={17} />);
}